import React from "react";
import Grid from "@material-ui/core/Grid";
import ColAtm from "../../../../atomic/Col/Col";
import OverFlowText from "../../../../molecules/OverFlowText/OverFlowText";
import BlockAtm from "../../../../atomic/Block/Block";
import {Link} from "react-router-dom";
import {PAYMENT_SETUP_SHORT} from "../../../../../constants/appUrls.constants";

const PaymentsBox = (props) => {
    const { paymentTypeList, maxPosCount, currentSetupCount } = props;

    const isLimitReached = maxPosCount > 0 && currentSetupCount >= maxPosCount;
    const isDisabled = !paymentTypeList.has_setup && isLimitReached;

    const content = (
        <BlockAtm className="offer-fact-border-box fact-border-box">
            <label htmlFor={paymentTypeList.id}
                className={paymentTypeList.has_setup ? "active-pos channel-logo-bg" : isDisabled ? "passive-pos channel-disabled" : "passive-pos"}>
                <label htmlFor={paymentTypeList.id}>
                    <Grid item xs={12} className="cancellation-info-col">
                        <ColAtm className="channel-logo pos-relative">
                            <label>
                                {paymentTypeList.has_setup &&
                                    <i className="channel-active-icon fad fa-dot-circle green" />
                                }
                                <div style={{ position: 'relative', display: 'inline-block' }}>
                                    <img src={'/assets/img/logo/banks-logo/' + paymentTypeList.bank_code + '.jpg'} alt={paymentTypeList.bank_code} />
                                    {isDisabled &&
                                        <i className="fad fa-lock" style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            fontSize: 45,
                                            color: '#64748b',
                                            opacity: 0.85,
                                        }} />
                                    }
                                </div>
                            </label>
                        </ColAtm>
                    </Grid>
                    <OverFlowText>{paymentTypeList.name}</OverFlowText>
                </label>
            </label>
        </BlockAtm>
    );

    return (
        <Grid item className="offer-fact-col pos-relative" xs={6} sm={4} md={2}>
            {isDisabled
                ? content
                : <Link to={PAYMENT_SETUP_SHORT + paymentTypeList.id}>{content}</Link>
            }
        </Grid>
    );
};

export default PaymentsBox;
